
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5727',
  depVersions: {
  "data-privacy-request-ui": "static-1.5727",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9868",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8236",
  "hub-http-shared-msw-handlers": "static-1.10462",
  "hubspot-dlb": "static-2.1877",
  "HubStyleTokens": "static-2.11685",
  "I18n": "static-7.1651",
  "jasmine-runner": "static-1.6664",
  "quartz": "static-1.7314",
  "react-dlb": "static-1.83",
  "rpc-client-utils": "static-1.4871",
  "ui-components-test-utils": "static-1.5822",
  "UIComponents": "static-3.8631",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.89",
  "foundations-assets": "static-1.5085",
  "foundations-components": "static-1.8323",
  "foundations-components-test-utils": "static-1.5806",
  "foundations-theming": "static-1.4658",
  "hub-http": "static-1.6427",
  "quartz-config": "static-1.1092",
  "quartz-core": "static-1.6533",
  "quartz-routing": "static-1.744",
  "quick-fetch": "static-1.4063",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-rhumb": "static-1.16914",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11357",
  "usage-tracker": "static-1.7564",
  "usage-tracker-anonymous": "static-1.5981",
  "usage-tracker-core": "static-1.7414",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4282",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3547",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3591",
  "quartz-webpack": "static-1.3538",
  "bend-plugin-quartz-routing": "static-1.392",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3347",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "ts-schema": "static-1.4227",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "react-utils": "static-2.5487",
  "StyleGuideUI": "static-3.491",
  "jasmine": "static-4.4533",
  "bend-plugin-chirp-manifest": "static-1.281",
  "chirp-fetch": "static-1.2098",
  "HubStyle": "static-2.11992",
  "ui-addon-draggable": "static-3.4966",
  "cssUtils": "static-1.855",
  "hs-story-utils": "static-1.9636",
  "icons": "static-2.668",
  "react-create-root-preference": "static-1.51",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1215",
  "bend-plugin-foundations-components": "static-1.4592",
  "floating-ui": "static-1.60",
  "foundations-theming-specialty": "static-1.2374",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2364",
  "ui-fonts": "static-1.947",
  "foundations-components-legacy": "static-1.1348",
  "bend-plugin-foundations-theming": "static-1.3141",
  "foundations-theming-base": "static-1.3643",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.227",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.859",
  "hubspotter-http": "static-1.4798",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.989",
  "quartz-head": "static-1.979",
  "quartz-i18n": "static-1.989",
  "quartz-test": "static-1.989",
  "quartz-tracking": "static-1.693",
  "trellis-components": "static-1.2383",
  "usage-tracker-container": "static-1.7554",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3336",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.74",
  "sassPrefix": "static-1.160",
  "hubspotter-http-shared-msw-handlers": "static-1.10460",
  "usage-tracker-session-replay": "static-1.5250",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1166",
  "tanstack-virtual": "static-1.35",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5727",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9868",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8236",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10462",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "HubStyleTokens": "/HubStyleTokens/static-2.11685",
  "I18n": "/I18n/static-7.1651",
  "jasmine-runner": "/jasmine-runner/static-1.6664",
  "quartz": "/quartz/static-1.7314",
  "react-dlb": "/react-dlb/static-1.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.4871",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5822",
  "UIComponents": "/UIComponents/static-3.8631",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "foundations-assets": "/foundations-assets/static-1.5085",
  "foundations-components": "/foundations-components/static-1.8323",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5806",
  "foundations-theming": "/foundations-theming/static-1.4658",
  "hub-http": "/hub-http/static-1.6427",
  "quartz-config": "/quartz-config/static-1.1092",
  "quartz-core": "/quartz-core/static-1.6533",
  "quartz-routing": "/quartz-routing/static-1.744",
  "quick-fetch": "/quick-fetch/static-1.4063",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-rhumb": "/react-rhumb/static-1.16914",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
  "usage-tracker": "/usage-tracker/static-1.7564",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5981",
  "usage-tracker-core": "/usage-tracker-core/static-1.7414",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3547",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3591",
  "quartz-webpack": "/quartz-webpack/static-1.3538",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.392",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3347",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "ts-schema": "/ts-schema/static-1.4227",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "react-utils": "/react-utils/static-2.5487",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "jasmine": "/jasmine/static-4.4533",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.281",
  "chirp-fetch": "/chirp-fetch/static-1.2098",
  "HubStyle": "/HubStyle/static-2.11992",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4966",
  "cssUtils": "/cssUtils/static-1.855",
  "hs-story-utils": "/hs-story-utils/static-1.9636",
  "icons": "/icons/static-2.668",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1215",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4592",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2374",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2364",
  "ui-fonts": "/ui-fonts/static-1.947",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1348",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3141",
  "foundations-theming-base": "/foundations-theming-base/static-1.3643",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.227",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "hubspotter-http": "/hubspotter-http/static-1.4798",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.989",
  "quartz-head": "/quartz-head/static-1.979",
  "quartz-i18n": "/quartz-i18n/static-1.989",
  "quartz-test": "/quartz-test/static-1.989",
  "quartz-tracking": "/quartz-tracking/static-1.693",
  "trellis-components": "/trellis-components/static-1.2383",
  "usage-tracker-container": "/usage-tracker-container/static-1.7554",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3336",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.74",
  "sassPrefix": "/sassPrefix/static-1.160",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10460",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5250",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1166",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
